import React from "react";
interface Props {
  children: React.ReactNode;
  onClick?: () => void;
}
export default function DashedCard(props: Props) {
  return (
    <div
      className="add-first-item-btn d-flex justify-content-center align-items-center p-4"
      onClick={props.onClick}
    >
      <div>{props.children}</div>
    </div>
  );
}
